import {Link} from "react-router-dom";
import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile
} from "react-device-detect";

export function Footer(props) {
    const TextTranslate = {
        eng_site: {
            ru: 'ENGLISH SITE',
            en: 'РУССКИЙ САЙТ'
        },
        fastlink: {
            ru: 'БЫСТРЫЕ ССЫЛКИ',
            en: 'FAST LINKS'
        },
        products: {
            ru: 'Продукты',
            en: 'Products'
        },
        solutions: {
            ru: 'Решения',
            en: 'Solutions'
        },
        feedback: {
            ru: 'Оставить заявку',
            en: 'Feedback'
        },
        policy: {
            ru: 'Политика конфиденциальности',
            en: 'Privacy policy'
        },
        policypersonal: {
            ru: 'Политика в отношении персональных данных',
            en: 'Personal data policy'
        },
        feedbackupper: {
            ru: 'ОСТАВИТЬ ЗАЯВКУ',
            en: 'FEEDBACK'
        },
        company: {
            ru: 'КОМПАНИЯ',
            en: 'Company'
        },
        aboutcompany: {
            ru: 'О компании',
            en: 'About company'
        },
        contacts: {
            ru: 'Контакты',
            en: 'Contacts'
        }
    };
    if (isBrowser) {
        return (
            <footer className={'footer'}>
                <div className={'col-footer'}>
                    {/*<p className={'text-footer-h'}>{TextTranslate.fastlink[props.Lang]}</p>*/}
                    {/*<p className={'text-footer-p'}><Link to={'/products'}>{TextTranslate.products[props.Lang]}</Link></p>*/}
                    <p className={'text-footer-p'}><a target={'_blank'} href={'./Privacy policy overcom 2021.pdf'} rel="noreferrer">{TextTranslate.policy[props.Lang]}</a>
                    </p>
                    <p className={'text-footer-p'}><Link to={'/solutions'}>{TextTranslate.solutions[props.Lang]}</Link>
                    </p>
                    <p className={'text-footer-p'}><Link to={'/feedback'}>{TextTranslate.feedback[props.Lang]}</Link>
                    </p>
                </div>
                <div className={'col-footer'}>
                    {/*<p className={'text-footer-h'}>{TextTranslate.company[props.Lang]}</p>*/}
                    <p className={'text-footer-p'}><a target={'_blank'} href={'./personal_data_policy.pdf'} rel="noreferrer">{TextTranslate.policypersonal[props.Lang]}</a>
                    </p>
                    <p className={'text-footer-p'}><Link
                        to={'/aboutcompany'}>{TextTranslate.aboutcompany[props.Lang]}</Link></p>
                    <p className={'text-footer-p'}><Link to={'/contacts'}>{TextTranslate.contacts[props.Lang]}</Link>
                    </p>
                </div>
                <div>
                    <img className={'img_footer_logo'} src={'./OVERCOM_LOGO_COLOR@3x.png'}/>
                    <p className={'text-footer-p p-padding-top'}>{props.Lang === 'ru' ? `© 2015-${new Date().getFullYear()} ООО"ОВЕРКОМ"` : `© 2015-${new Date().getFullYear()} "OVERCOM" LLC`}</p>
                </div>
            </footer>
        )
    }
    return (
        <>
            <footer>
                <div>
                    <img className={'img_footer_logo'} src={'./OVERCOM_LOGO_COLOR@3x.png'}/>
                    <p className={'text-footer-p p-padding-top'}>{props.Lang === 'ru' ? `© 2015-${new Date().getFullYear()} ООО"ОВЕРКОМ"` : `© 2015-${new Date().getFullYear()} "OVERCOM" LLC`}</p>
                </div>
                <div className={'footer-mobile-col'}>
                    <p className={'text-footer-h'} onClick={() => {
                        if(props.Lang === 'ru'){
                            props.setLang('en');
                        }
                        else{
                            props.setLang('ru');
                        }
                    }}>{TextTranslate.eng_site[props.Lang]} <i><img
                        src={"/LINK_ARROW.svg"} className={'text-footer-h-img'}/></i></p>
                    <p className={'text-footer-p'}><a target={'_blank'} href={'./Privacy policy overcom 2021.pdf'} rel="noreferrer">{TextTranslate.policy[props.Lang]}</a>
                    </p>
                    <p className={'text-footer-p'}><a target={'_blank'} href={'./personal_data_policy.pdf'} rel="noreferrer">{TextTranslate.policypersonal[props.Lang]}</a>
                    </p>
                    {/*<p className={'text-footer-p'}><Link to={'/products'}>{TextTranslate.products[props.Lang]}</Link></p>*/}
                    <p className={'text-footer-p'}><Link to={'/solutions'}>{TextTranslate.solutions[props.Lang]}</Link>
                    </p>
                    <p className={'text-footer-p'}><Link to={'/feedback'}>{TextTranslate.feedback[props.Lang]}</Link>
                    </p>
                </div>
            </footer>
            <div className={'footer-mobile-button'}>
                <span className={'button-footer-feedback-span'}>
                    <Link to={'/feedback'}>
                        {TextTranslate.feedbackupper[props.Lang]}
                    </Link>
                </span>
            </div>
        </>
    );
}
